import React, { forwardRef, useRef, useEffect, useMemo, useState } from "react";
//import "../tempcss/global.css";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { MdExpandMore } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import { GoArrowDown } from "react-icons/go";
import { GoArrowUp } from "react-icons/go";
// import { CiStar } from "react-icons/ci";
// import RouteCardNormal from "./RouteCardNormal";
// import axios from "axios";
import axiosInstance from "../CommonGlobals/axiosInstance.js";

import RouteCardNew from "./RouteCardNew";
import { Slide } from "@mui/material";
import { FiFilter } from "react-icons/fi";

import {
  Dialog,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
} from "@mui/material";

import map from "lodash/map";
// import uniq from "lodash/uniq";
import { flatten, lowerCase, orderBy, set, uniqBy } from "lodash";
// import BookingDateSection3 from "../mycomps/BookingDateSection3";
import ModifySearchBookingDate from "../mycomps/ModifySearchBookingDate";

// import { PathContext } from "../CommonGlobals/PathContext";
import { PathProvider } from "../CommonGlobals/PathProvider";
// import { canTextBeChildOfNode } from "html-react-parser/lib/utilities";

import GlobalLoaderRoot from "../CommonGlobals/GlobalLoaderRoot.jsx";

import { useAppGlobalState } from "../CommonGlobals/Store";
// import { LoadingProvider } from "../CommonGlobals/LoadingContext.jsx";

// import LoaderComponents from "../CommonGlobals/LoaderComponents.jsx";
// import ComponentLevelLoader from "../CommonGlobals/ComponentLevelLoader.jsx";

// import { DotLottieReact } from '@lottiefiles/dotlottie-react';

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import axios from "axios";
import { MISBookingMode } from "../CommonGlobals/TRMISBookingMode";
import { sendEventTobackend } from "../CommonGlobals/sendEventDataTobackend";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// const amenitiesList = [
//   "Reading Light",
//   "Fire Extinguisher",
//   "Mobile Charging Point",
//   "M-ticket Supported",
//   "Emergency exit",
//   "Live Bus Tracking",
//   "Hammer",
//   "USB port for charger",
//   "Helpline Number",
// ];

const JourneyList = ({
  routeapi,
  routeReturnapi = null,
  citiesDataUrl = "/cities.json",
  paymentUrl = "/payments",
  bookingPageUrl,
  layouturl,
  journeySeatsInfo,
  BookSeatsTempEndPoint,
  ServerBaseUrl,
  LocalwebUrl,
  redirectToPg,
  defaultCalendarConfigApi,
  onchangeDestChangeCalendarConfigApi,
  SignedPassenger,
  modifyAutoSearch = 1,
  alterSeatBookingInfo = null,
  postponeOrpreponeResultUrl = null,
}) => {
   console.log(SignedPassenger);
   console.log(alterSeatBookingInfo);
  // console.log(routeReturnapi);
  // console.log(bookingPageUrl); 

  // console.log(defaultCalendarConfigApi);
  // console.log(onchangeDestChangeCalendarConfigApi);

  const [journeySearchResults, setJourneySearchResults] = useState(null);

  const [returnJourneySearchResults, setReturnJourneySearchResults] = useState(null);

  const [open, setOpen] = useState(false);
  const [smFilterSelectedMenu, setSmFilterSelectedMenu] = useState("Sort");

  const [journeyData, setJourneyData] = useState();
  const [returnJourneyData, setReturnJourneyData] = useState();
  const [filteredJourneyData, setFilteredJourneyData] = useState();
  const [returnFilteredJourneyData, setReturnFilteredJourneyData] = useState(); 
  const [uniqBoardings, setUniqBoardings] = useState();
  const [uniqDroppings, setUniqDroppings] = useState();
  const [uniqBustypes, setUniqBustypes] = useState();
  const [uniqAmenities, setUniqAmenities] = useState();


  // for return journey


  const [uniqBoardingsReturn, setUniqBoardingsReturn] = useState();
  const [uniqDroppingsReturn, setUniqDroppingsReturn] = useState();
  const [uniqBustypesReturn, setUniqBustypesReturn] = useState();
  const [uniqAmenitiesReturn, setUniqAmenitiesReturn] = useState();

  const [sortType, setSortType] = useState("");
  const [sortFieldType, setSortFieldType] = useState("");
  const [sortFieldColumn, setSortFieldColumn] = useState("");


  const [sortTypeReturn, setSortTypeReturn] = useState("");
  const [sortFieldTypeReturn, setSortFieldTypeReturn] = useState("");
  const [sortFieldColumnReturn, setSortFieldColumnReturn] = useState("");

  const [selectedBoardings, setSelectedBoardings] = useState([]);
  const [selectedDroppings, setSelectedDroppings] = useState([]);
  const [selectedBusTypes, setSelectedBusTypes] = useState([]);


  // for return Data Journey 

  const [selectedBoardingsReturn, setSelectedBoardingsReturn] = useState([]);
  const [selectedDroppingsReturn, setSelectedDroppingsReturn] = useState([]);
  const [selectedBusTypesReturn, setSelectedBusTypesReturn] = useState([]);

  // view more for boarding and dropping points

  const [showAllBoardings, setShowAllBoardings] = useState(false);
  const [displayBoardingsList, setDisplayBoardingsList] = useState();

  const [showAllDroppings, setShowAllDroppings] = useState(false);
  const [displayDroppingsList, setDisplayDroppingsList] = useState();


  // for return journey


  const [showAllBoardingsReturn, setShowAllBoardingsReturn] = useState(false);
  const [displayBoardingsListReturn, setDisplayBoardingsListReturn] = useState();

  const [showAllDroppingsReturn, setShowAllDroppingsReturn] = useState(false);
  const [displayDroppingsListReturn, setDisplayDroppingsListReturn] = useState();

  // filter section variables

  const [clearFilter, setClearFilter] = useState(false);
  const [liveTracking, setLiveTracking] = useState(false);

  // filter for DepartureTime

  const [earlyDepartMorning, setDepartEarlyMorning] = useState(false);
  const [departMorning, setDepartMorning] = useState(false);
  const [departAfterNoon, setDepartAfterNoon] = useState(false);
  const [departEvening, setdepartEvening] = useState(false);

  // filter for Arrival Time

  const [earlyArrivalMorning, setArrivalEarlyMorning] = useState(false);
  const [arrivalMorning, setArrivalMorning] = useState(false);
  const [arrivalAfterNoon, setArrivalAfterNoon] = useState(false);
  const [arrivalEvening, setArrivalEvening] = useState(false);

  const [activeAmenities, setActiveAmenities] = useState([]);

  // arrival time and departure time as radios

  const [selectedArrival, setSelectedArrival] = useState("");
  const [selectedDeparture, setSelectedDeparture] = useState("");


  const [selectedArrivalReturn, setSelectedArrivalReturn] = useState("");
  const [selectedDepartureReturn, setSelectedDepartureReturn] = useState("");

  // checking small radio is checked
  const [sortingSmScreenRadio, setSortingSmScreenRadio] = useState("Departure");
    const [sortingSmScreenRadioReturn, setSortingSmScreenRadioReturn] = useState("Departure");
  const [showAnimation, setShowAnimation] = useState(true);

  // journey paramters from url

  const [journeySourceCity, setJourneySourceCity] = useState({});
  const [journeyDestinationCity, setJourneyDestinationCity] = useState({});

  const [journeyOnwardDate, setJourneyOnwardDate] = useState("");
  const [journeyReturnDate, setJourneyReturnDate] = useState("");


  const [journeyReturnSourceCity, setJourneyReturnSourceCity] = useState({});
  const [journeyReturnDestinationCity, setJourneyReturnDestinationCity] = useState({});

  const [globalData, setGlobalData] = useAppGlobalState();

  const [calendarDefaultConfig, setCalendarDefaultConfig] = useState(null);

  const [tabValue, setTabValue] = useState("1");

  const [isReturnJourneyExsit, setIsReturnJourneyExsit] = useState(false);

  const [currentJourney, setCurrentJourney] = useState("onward");

  const [isFilteredOnce, setIsFilteredOnce] =  useState(false);


  const [showSearchSmallPanel, setShowSearchSmallPanel] = useState(false);
  const [journeyDialogOpen, setJourneyDialogOpen] = useState(false); 
  const [activeJourneyId, setActiveJourneyId] = useState(null); // NEW
  
  const openRef = useRef(open);
  
  useEffect(()=>{
    console.log("open value changed");
    console.log(open);
     openRef.current = open;
  },[open]);// Controlled from here now!



  useEffect(() => {
    const handleNativeBackButtonClicked = () => {
      console.log("Native Back Button Clicked");
      console.log("filter : ", open);
       const currentOpenValue = openRef.current

      // 1. If Card Dialog is open, close it first
      if (journeyDialogOpen) {
        console.log("journeyDialogOpen is true, closing it now");
        setJourneyDialogOpen(false);
        setActiveJourneyId(null); // Reset the active journey ID when closing the dialog
      } 
      // 2. If Card Dialog is closed but Modify is open, close Modify
      else if (showSearchSmallPanel) {
        console.log("showSearchSmallPanel is true, closing it now");
        setShowSearchSmallPanel(false);
      }else if(currentOpenValue){
        console.log("open is true, closing it now");
        handleClose();
      } 
      // 3. If both are closed, trigger native postMessage
      else {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              messageType: "operation",
              action: "backpress",
              payload: "",
              pgselector: "",
            })
          );
        }
      }
    };

    window.addEventListener('nativeHarwareBackButtonClick', handleNativeBackButtonClicked);
    return () => {
      window.removeEventListener('nativeHarwareBackButtonClick', handleNativeBackButtonClicked);
    };
  }, [journeyDialogOpen, showSearchSmallPanel, open]);




     useEffect(() => {
      const handleMobileIds = (event) => {

        console.log("mobileIdsReady event received:", event.detail);
        const { regId, sessId } = event.detail;
        console.log("Registration ID:", regId);
        console.log("Session ID:", sessId);

        window.RegistrationUniqueIDFromMobile = regId;
        window.SessionUniqueIDFromMobile = sessId;
          // setCurrentDeviceId(regId);
          // setCurrentDeviceDaySession({ sessionId: sessId });
        // setDeviceId(regId);
        // setDeviceDaySession({ sessionId: sessId });
      };
    
      // Listen for the custom event fired by the app
      window.addEventListener('mobileIdsReady', handleMobileIds);

       if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              messageType: 'operation',
              action: 'mobileIdsReady_listener_ready',
              listener: 'mobileIdsReady',
            })
          );
          console.log('Posted web_listener_ready to RN');
        }
    
      // Fallback check if it was somehow already there
      if (window.RegistrationUniqueIDFromMobile) {
        // setCurrentDeviceId(window.RegistrationUniqueIDFromMobile);
        // setCurrentDeviceDaySession({ sessionId: window.SessionUniqueIDFromMobile });
        // setDeviceId(window.RegistrationUniqueIDFromMobile);
        // setDeviceDaySession({ sessionId: window.SessionUniqueIDFromMobile });
      }
    
      return () => window.removeEventListener('mobileIdsReady', handleMobileIds);
    }, []);


  



  useEffect(()=>{

     if(SignedPassenger){
       setGlobalData((prev)=>({
        ...prev,
        SignedPassenger:SignedPassenger,        
       }))
     }

  },[SignedPassenger]);

  useEffect(() => {
    axiosInstance
      .get(defaultCalendarConfigApi, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // console.log(res.data);
        setCalendarDefaultConfig(res.data);
      })
      .catch((error) => {
        alert(error);
      });
  }, [defaultCalendarConfigApi]);


 



  useEffect(() => {

    setGlobalData((prev) => ({
      ...prev,
      onwardDate: journeyOnwardDate,
      ServerBaseUrl: ServerBaseUrl,
      LocalwebUrl: LocalwebUrl,
    }));
  }, [journeyOnwardDate]);

  useEffect(() => {
    setGlobalData((prev) => ({
      ...prev,
      sourceObject: journeySourceCity,
    }));
  }, [journeySourceCity]);

  useEffect(() => {
    setGlobalData((prev) => ({
      ...prev,
      destinationObject: journeyDestinationCity,
    }));
  }, [journeyDestinationCity]);

  useEffect(() => {
    console.log(globalData); 
  }, [globalData]);




  useEffect(() => {
    if (currentJourney === "onward") {
       onwardJourneyFilterSet();
    }else{
      returnJourneyListFilterSet();
    }
  },[currentJourney]);

  // useEffect(() => {
  //   onwardJourneyFilterSet();
  //   setTimeout(()=>{
  //      returnJourneyListFilterSet();
  //   },200);
  // },[]);


  useEffect(() => {
    setGlobalData((prev) => ({ ...prev, journeyType: currentJourney,  isReturnJourneyExist:isReturnJourneyExsit }));
  },[isReturnJourneyExsit])

  // useEffect(()=>{
  //  // console.log(isLoading);
  // },[isLoading])

  const handleJourneyTabChange = (event, newValue) => {
    if(isReturnJourneyExsit){
      setCurrentJourney(newValue === "1" ? "onward" : "return");
      setGlobalData((prev) => ({ ...prev, journeyType: newValue === "1" ? "onward" : "return",
        isReturnJourneyExist:isReturnJourneyExsit
       }));
      
    }else{
      setCurrentJourney("onward"); 
      setGlobalData((prev) => ({ ...prev, journeyType: newValue === "1" ? "onward" : "return",
        isReturnJourneyExist:isReturnJourneyExsit
       }));
    }
    setTabValue(newValue);
  };

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // loading settings

  // end of loading settings

  const handleSmMenuSelect = (menuitem) => {
    if (menuitem != "") {
      setSmFilterSelectedMenu(menuitem);
    }
  };

  useEffect(() => {
    // console.log(showAnimation);
  }, [showAnimation]);

  useEffect(() => {
    //console.log(paymentUrl);
  }, [paymentUrl]);

  useEffect(() => {
    //console.log(uniqAmenities)
  }, [uniqAmenities]);

  useEffect(()=>{
      setGlobalData((prev) => ({ ...prev, returnDate: journeyReturnDate }));
  },[journeyReturnDate]);

  useEffect(() => {
    //console.log(routeapi);
    const params = new URLSearchParams(routeapi.split("?")[1]);
    const fromCity = JSON.parse(params.get("source"));
    const toCity = JSON.parse(params.get("destination"));

    // console.log(fromCity);
    // console.log(toCity);
    setJourneySourceCity(fromCity);
    setJourneyDestinationCity(toCity);
    setJourneyOnwardDate(params.get("JourneyDate"));

    axiosInstance
      .get(routeapi, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        // console.log(res.data);
        if (res.data.Status === true) {
          if (res.data.ResponseData && res.data.ResponseData.length > 0) {
              setJourneySearchResults(res.data);
              setJourneyData(res.data.ResponseData);
              sendEventTobackend("JourneyListFound", null , 1);
          } else {
              setJourneySearchResults(res.data);
              setJourneyData([]);
              sendEventTobackend("JourneyListNotFound", null , 1);
          }
          // setJourneySearchResults(res.data);
          // setJourneyData(res.data.ResponseData);
        } else {
          alert("data not found");
        }
      })
      .catch((error) => {
        alert(error);
      });
  }, [routeapi]);


    useEffect(() => {
    if (routeReturnapi != null && routeReturnapi != "") {
      setIsReturnJourneyExsit(true);
    
      const params = new URLSearchParams(routeReturnapi.split("?")[1]);
      const fromCity = JSON.parse(params.get("source"));
      const toCity = JSON.parse(params.get("destination"));

      // console.log(fromCity);
      // console.log(toCity);
      setJourneyReturnSourceCity(fromCity);
      setJourneyReturnDestinationCity(toCity);
      setJourneyReturnDate(params.get("JourneyDate"));

      axiosInstance
        .get(routeReturnapi, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          // console.log(res.data);
          if (res.data.Status === true) {
            if (res.data.ResponseData && res.data.ResponseData.length > 0) {
              setReturnJourneySearchResults(res.data);
              setReturnJourneyData(res.data.ResponseData);
            } else {
              setReturnJourneySearchResults(res.data);
              setReturnJourneyData([]);
            }
            // setJourneySearchResults(res.data);
            // setJourneyData(res.data.ResponseData);
          } else {
            alert("Return Journey data not found");
          }
        })
        .catch((error) => {
          alert(error);
        });
    } else {
      setIsReturnJourneyExsit(false);
    }
  }, [routeReturnapi]);

  useEffect(() => {
    //console.log(journeyData);
      const fj = orderBy(journeyData, ["MBTSort"], ["asc"]);
     
     
      setFilteredJourneyData(fj);  
      onwardJourneyFilterSet();
  }, [journeyData]);



   useEffect(() => {
    //console.log(journeyData);
    const fj = orderBy(returnJourneyData, ["MBTSort"], ["asc"]);
    setReturnFilteredJourneyData(fj);
  
     returnJourneyListFilterSet();
  }, [returnJourneyData]);

  useEffect(() => {
    // console.log("does value change");
    // console.log(bookingPageUrl);
  }, [bookingPageUrl]);

  useEffect(() => {
    // console.log("layouturl value change");
    // console.log(layouturl);
  }, [layouturl]);

  useEffect(() => {
    if (uniqBoardings) {
      const dboarding = showAllBoardings
        ? uniqBoardings
        : uniqBoardings.slice(0, 2);
      setDisplayBoardingsList(dboarding);
    }
  }, [showAllBoardings]);

  useEffect(() => {
    // console.log("its dropping chnge");
    if (uniqDroppings) {
      const dboarding = showAllDroppings
        ? uniqDroppings
        : uniqDroppings.slice(0, 2);
      setDisplayDroppingsList(dboarding);
    }
  }, [showAllDroppings]);

  useEffect(() => {
    //console.log(filteredJourneyData);
  }, [filteredJourneyData]);

  useEffect(() => {
    // console.log(uniqBustypes);
  }, [uniqBustypes]);



  const handleTabChangeInDialog = (tabvaluefromdl) => {
      //alert("Showing Return Journey List");
      
      handleJourneyTabChange(event, tabvaluefromdl);
      
      // setTabValue(tabvaluefromdl)
  }

  // useEffect(()=>{
  // const scrollChipContainer = document.querySelector('.places-chips');
  // let isMouseDown = false;
  //   let startX;
  //   let scrollLeft;

  //   scrollChipContainer.addEventListener('mousedown', (e) => {
  //     isMouseDown = true;
  //     console.log('inside scroll'+ isMouseDown);
  //     startX = e.pageX - scrollChipContainer.offsetLeft;
  //     scrollLeft = scrollChipContainer.scrollLeft;
  //   });

  //   scrollChipContainer.addEventListener('mouseleave', () => {
  //     isMouseDown = false;
  //   });

  //   scrollChipContainer.addEventListener('mouseup', () => {
  //     isMouseDown = false;
  //   });

  //   scrollChipContainer.addEventListener('mousemove', (e) => {
  //     if (!isMouseDown) return;
  //     e.preventDefault();
  //     const x = e.pageX - scrollChipContainer.offsetLeft;
  //     const walk = (x - startX) * 2; // Adjust scroll speed
  //     scrollChipContainer.scrollLeft = scrollLeft - walk;
  //   });

  // },[])

  useEffect(() => {
    // console.log(journeySearchResults);
  }, [journeySearchResults]);

  const applyFilters = () => {
    console.log("Its called");
    setIsFilteredOnce(true);
    if (currentJourney === "onward" && journeyData) {
      let filtered = [...journeyData];

       console.log(filtered);

      if (selectedBusTypes.length > 0) {
        filtered = filtered.filter((j) =>
          selectedBusTypes.includes(j.CoachType),
        );
      }

      if (selectedBoardings.length > 0) {
        filtered = filtered.filter((j) =>
          j.Boardings.some((b) => selectedBoardings.includes(b.PointName)),
        );
      }

      if (selectedDroppings.length > 0) {
        filtered = filtered.filter((j) =>
          j.Droppings.some((d) => selectedDroppings.includes(d.PointName)),
        );
      }

      if (selectedDeparture) {
        // console.log(selectedDeparture);
        switch (selectedDeparture) {
          case "earlyDepartMorning":
            filtered = filtered.filter((j) => {
              return j.MBTSort < 600;
            });
            // console.log(filtered);
            break;
          case "departMorning":
            filtered = filtered.filter((j) => {
              return j.MBTSort >= 600 && j.MBTSort < 1200;
            });
            break;
          case "departAfterNoon":
            filtered = filtered.filter((j) => {
              return j.MBTSort >= 1200 && j.MBTSort < 1800;
            });
            break;
          case "departEvening":
            filtered = filtered.filter((j) => {
              return j.MBTSort >= 1800;
            });
            break;
        }
      }

      if (selectedArrival) {
        //  console.log(selectedArrival);
        switch (selectedArrival) {
          case "earlyArrivalMorning":
            //setDepartEarlyMorning((perv) => (perv = !perv));
            filtered = filtered.filter((j) => {
              return j.MDTSort < 600;
            });
            break;
          case "arrivalMorning":
            filtered = filtered.filter((j) => {
              return j.MDTSort >= 600 && j.MDTSort < 1200;
            });
            //setDepartMorning((perv) => (perv = !perv));
            break;
          case "arrivalAfterNoon":
            filtered = filtered.filter((j) => {
              return j.MDTSort >= 1200 && j.MDTSort < 1800;
            });
            //setDepartAfterNoon((perv) => (perv = !perv));
            break;
          case "arrivalEvening":
            filtered = filtered.filter((j) => {
              return j.MDTSort >= 1800;
            });
            //setdepartEvening((perv) => (perv = !perv));
            break;
        }
      }

      // if(activeAmenities.length > 0){
      //   filtered = jData.Amenities.filter(item => activeAmenityIds.includes(item.AmenityID));

      // }
      if (activeAmenities.length > 0) {
        filtered = filtered.filter((j) =>
          j.Amenities?.some((b) => activeAmenities.includes(b.AmenityID)),
        );
      }

      // console.log(activeAmenities);

      setFilteredJourneyData(filtered);
    }



  };



  const applyfiltersReturn = () =>{
     console.log("Its called return");
     setIsFilteredOnce(true);
    if (currentJourney === "return" && returnJourneyData) {

       
       let filtered = [...returnJourneyData];

       console.log(filtered);

      if (selectedBusTypesReturn.length > 0) {
        filtered = filtered.filter((j) =>
          selectedBusTypesReturn.includes(j.CoachType),
        );
      }

      if (selectedBoardingsReturn.length > 0) {
        filtered = filtered.filter((j) =>
          j.Boardings.some((b) => selectedBoardingsReturn.includes(b.PointName)),
        );
      }

      if (selectedDroppingsReturn.length > 0) {
        filtered = filtered.filter((j) =>
          j.Droppings.some((d) => selectedDroppingsReturn.includes(d.PointName)),
        );
      }

      if (selectedDepartureReturn) {
        // console.log(selectedDeparture);
        switch (selectedDepartureReturn) {
          case "earlyDepartMorning":
            filtered = filtered.filter((j) => {
              return j.MBTSort < 600;
            });
            // console.log(filtered);
            break;
          case "departMorning":
            filtered = filtered.filter((j) => {
              return j.MBTSort >= 600 && j.MBTSort < 1200;
            });
            break;
          case "departAfterNoon":
            filtered = filtered.filter((j) => {
              return j.MBTSort >= 1200 && j.MBTSort < 1800;
            });
            break;
          case "departEvening":
            filtered = filtered.filter((j) => {
              return j.MBTSort >= 1800;
            });
            break;
        }
      }

      if (selectedArrivalReturn) {
        //  console.log(selectedArrival);
        switch (selectedArrivalReturn) {
          case "earlyArrivalMorning":
            //setDepartEarlyMorning((perv) => (perv = !perv));
            filtered = filtered.filter((j) => {
              return j.MDTSort < 600;
            });
            break;
          case "arrivalMorning":
            filtered = filtered.filter((j) => {
              return j.MDTSort >= 600 && j.MDTSort < 1200;
            });
            //setDepartMorning((perv) => (perv = !perv));
            break;
          case "arrivalAfterNoon":
            filtered = filtered.filter((j) => {
              return j.MDTSort >= 1200 && j.MDTSort < 1800;
            });
            //setDepartAfterNoon((perv) => (perv = !perv));
            break;
          case "arrivalEvening":
            filtered = filtered.filter((j) => {
              return j.MDTSort >= 1800;
            });
            //setdepartEvening((perv) => (perv = !perv));
            break;
        }
      }

      // if(activeAmenities.length > 0){
      //   filtered = jData.Amenities.filter(item => activeAmenityIds.includes(item.AmenityID));

      // }
      if (activeAmenities.length > 0) {
        filtered = filtered.filter((j) =>
          j.Amenities?.some((b) => activeAmenities.includes(b.AmenityID)),
        );
      }

      // console.log(activeAmenities);

      setReturnFilteredJourneyData(filtered);
    }
  }

  const sortBy = (type) => {
    if (type == "filters") {
      // console.log();
    } else {
      setSortFieldColumn(type);
      let fieldtype = "";
      const newSortType = sortType === "desc" ? "asc" : "desc";
     
      switch (type) {
        case "Departure":
          fieldtype = "MBTSort";
          break;
        case "Duration":
          fieldtype = "SortDuration";
          break;
        case "Arrival":
          fieldtype = "MDTSort";
          break;
        case "Seat":
          fieldtype = "EmptySeatCount";
          break;
        case "Fare":
          fieldtype = "DisplayFare";
          break;
      }
      setSortType(newSortType);
      fieldtype != "" ? setSortFieldType(fieldtype) : setSortFieldType("");
      // console.log(type);
    }
  };


  
  const sortByReturn = (type) => {
    if (type == "filters") {
      // console.log();
    } else {
      setSortFieldColumnReturn(type);
      let fieldtype = "";
      const newSortType = sortTypeReturn === "desc" ? "asc" : "desc";
      console.log(newSortType)
      switch (type) {
        case "Departure":
          fieldtype = "MBTSort";
          break;
        case "Duration":
          fieldtype = "SortDuration";
          break;
        case "Arrival":
          fieldtype = "MDTSort";
          break;
        case "Seat":
          fieldtype = "EmptySeatCount";
          break;
        case "Fare":
          fieldtype = "DisplayFare";
          break;
      }
      setSortTypeReturn(newSortType);
      fieldtype != "" ? setSortFieldTypeReturn(fieldtype) : setSortFieldTypeReturn("");
      // console.log(type);
    }
  };

  const handleCheckboxChange = (value, type) => {
    const updater = {
      boarding: setSelectedBoardings,
      dropping: setSelectedDroppings,
      bustype: setSelectedBusTypes,
    }[type];

    updater((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };
  const handleCheckboxChangeReturn = (value, type) => {
    const updater = {
      boarding: setSelectedBoardingsReturn,
      dropping: setSelectedDroppingsReturn,
      bustype: setSelectedBusTypesReturn,
    }[type]; 

    updater((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  useEffect(() => {
    // console.log(selectedBoardings);
    // console.log(selectedDroppings);
    // console.log(selectedBusTypes);
    applyFilters();
  }, [
    selectedBoardings,
    selectedDroppings,
    selectedBusTypes,
    selectedArrival,
    selectedDeparture,
  ]);


    useEffect(() => {
    // console.log(selectedBoardings);
    // console.log(selectedDroppings);
    // console.log(selectedBusTypes);
    applyfiltersReturn();
  }, [
    selectedBoardingsReturn,
    selectedDroppingsReturn,
    selectedBusTypesReturn,
    selectedArrivalReturn,
    selectedDepartureReturn,
  ]);

  useMemo(() => {
    // let filtered = [...journeyData];

    let filtered = orderBy(filteredJourneyData, [sortFieldType], [sortType]);
    setFilteredJourneyData(filtered);
  }, [sortType, sortFieldType]);


   useMemo(() => {
    // let filtered = [...journeyData];

    let filtered = orderBy(returnFilteredJourneyData, [sortFieldTypeReturn], [sortTypeReturn]);
    setReturnFilteredJourneyData(filtered);
  }, [sortTypeReturn, sortFieldTypeReturn]);

  const getSortIcon = (field) => {
    // console.log("inside get Sort Icons");
    // console.log(sortType);
    // console.log(sortFieldType);
    if (sortFieldColumn != field) return null;
    return sortType === "asc" ? <GoArrowUp /> : <GoArrowDown />;
  };


    const getSortIconReturn = (field) => {
    // console.log("inside get Sort Icons");
    // console.log(sortType);
    // console.log(sortFieldType);
    if (sortFieldColumnReturn != field) return null;
    return sortTypeReturn === "asc" ? <GoArrowUp /> : <GoArrowDown />;
  };

  const handleFilterButtonsClick = (buttonType) => {
    switch (buttonType) {
      case "earlyDepartMorning":
        setDepartEarlyMorning((perv) => (perv = !perv));
        break;
      case "departMorning":
        setDepartMorning((perv) => (perv = !perv));
        break;
      case "departAfterNoon":
        setDepartAfterNoon((perv) => (perv = !perv));
        break;
      case "departEvening":
        setdepartEvening((perv) => (perv = !perv));
        break;

      //  arrivings

      case "earlyArrivalMorning":
        setArrivalEarlyMorning((perv) => (perv = !perv));
        break;
      case "arrivalMorning":
        setArrivalMorning((perv) => (perv = !perv));
        break;
      case "arrivalAfterNoon":
        setArrivalAfterNoon((perv) => (perv = !perv));
        break;
      case "arrivalEvening":
        setArrivalEvening((perv) => (perv = !perv));
        break;
    }
  };

  const toggleAmenity = (amenity) => {
    // console.log(amenity);

    setActiveAmenities((prev) => {
      // console.log(prev.filter((item) => item === amenity.AmenityID) );
      return prev.includes(amenity.AmenityID)
        ? prev.filter((item) => item != amenity.AmenityID)
        : [...prev, amenity.AmenityID];
    });
  };

  useEffect(() => {
    //console.log(activeAmenities);
    applyFilters();
  }, [activeAmenities]);

  const filter_board_dropiing = (e, type) => {
    var key = e.target.value;
    //console.log(key.length);
    if (type == "boardings") {
      if (key.length == 0) {
        if (showAllBoardings) {
          setDisplayBoardingsList(uniqBoardings);
        } else {
          setDisplayBoardingsList(uniqBoardings.slice(0, 2));
        }
        return;
      }

      const res = uniqBoardings.filter((j) => {
        return lowerCase(j.PointName).includes(lowerCase(key));
      });
      //console.log(res);

      setDisplayBoardingsList(res);
    }

    if (type == "droppings") {
      if (key.length == 0) {
        if (showAllDroppings) {
          setDisplayDroppingsList(uniqDroppings);
        } else {
          setDisplayDroppingsList(uniqDroppings.slice(0, 4));
        }
        return;
      }

      const res = uniqDroppings.filter((j) => {
        return lowerCase(j.PointName).includes(lowerCase(key));
      });
      // console.log(res);

      setDisplayDroppingsList(res);
    }
  };
  const filter_board_dropiingReturn = (e, type) => {
    var key = e.target.value;
    //console.log(key.length);
    if (type == "boardings") {
      if (key.length == 0) {
        if (showAllBoardingsReturn) {
          setDisplayBoardingsListReturn(uniqBoardings);
        } else {
          setDisplayBoardingsListReturn(uniqBoardings.slice(0, 2));
        }
        return;
      }

      const res = uniqBoardingsReturn.filter((j) => {
        return lowerCase(j.PointName).includes(lowerCase(key));
      });
      //console.log(res);

      setDisplayBoardingsListReturn(res);
    }

    if (type == "droppings") {
      if (key.length == 0) {
        if (showAllDroppingsReturn) {
          setDisplayDroppingsListReturn(uniqDroppingsReturn);
        } else {
          setDisplayDroppingsListReturn(uniqDroppingsReturn.slice(0, 4));
        }
        return;
      }

      const res = uniqDroppingsReturn.filter((j) => {
        return lowerCase(j.PointName).includes(lowerCase(key));
      });
      // console.log(res);

      setDisplayDroppingsListReturn(res);
    }
  };


  const onwardJourneyFilterSet = () => {

    if (currentJourney === "onward" && journeyData) {
      
     
      

      // get uniq boarding points from response
      const allBoardings = map(journeyData, "Boardings");
      // console.log("All Boardings");
      // console.log(allBoardings);
      // console.log(flatten(allBoardings));
      let allBoardingsPoints = uniqBy(flatten(allBoardings), "PointName");
      //console.log(allBoardingsPoints);
      allBoardingsPoints = orderBy(
        allBoardingsPoints,
        [(point) => point.PointName.toLowerCase()],
        ["asc"],
      );
      setUniqBoardings(allBoardingsPoints);
      const dboarding = showAllBoardings
        ? allBoardingsPoints
        : allBoardingsPoints.slice(0, 2);
      setDisplayBoardingsList(dboarding);

      // get uniq dropping points from response
      const alldroppings = map(journeyData, "Droppings");
      // console.log("All Droppings");
      // console.log(alldroppings);
      // console.log(flatten(alldroppings));
      let allDroppingPoints = uniqBy(flatten(alldroppings), "PointName");
      //console.log(allDroppingPoints);
      allDroppingPoints = orderBy(
        allDroppingPoints,
        [(point) => point.PointName.toLowerCase()],
        ["asc"],
      );
      //console.log(allDroppingPoints);
      setUniqDroppings(allDroppingPoints);
      const dDropping = showAllDroppings
        ? allDroppingPoints
        : allDroppingPoints.slice(0, 2);
      setDisplayDroppingsList(dDropping);

      // get uniq Bus types  from response
      //const allbustypes = map(journeyData, "CoachType");
      const allbustypes = uniqBy(journeyData, "CoachType");
      // console.log("All Bus Types");
      // console.log(allbustypes);

      setUniqBustypes(allbustypes);
      //console.log("Amentires ")

      const allAmenities = map(journeyData, "Amenities");
      //console.log(allAmenities);

      const uniqAmenitieslist = uniqBy(flatten(allAmenities), "AmenityName");

      //console.log(uniqAmenitieslist);
      setUniqAmenities(uniqAmenitieslist);

      // console.log(flatten(alldroppings));
      // const allDroppingPoints = uniqBy(flatten(alldroppings), "PointName");
      // console.log(allDroppingPoints);
      // setUniqDroppings(allDroppingPoints);
    }

  }





  const returnJourneyListFilterSet = () => {
    
    
    if (currentJourney === "return" && returnJourneyData) {
      

      // get uniq boarding points from response
      const allBoardings = map(returnJourneyData, "Boardings");
      // console.log("All Boardings");
      // console.log(allBoardings);
      // console.log(flatten(allBoardings));
      let allBoardingsPoints = uniqBy(flatten(allBoardings), "PointName");
      //console.log(allBoardingsPoints);
      allBoardingsPoints = orderBy(
        allBoardingsPoints,
        [(point) => point.PointName.toLowerCase()],
        ["asc"],
      );
      setUniqBoardingsReturn(allBoardingsPoints);
      const dboarding = showAllBoardings
        ? allBoardingsPoints
        : allBoardingsPoints.slice(0, 2);
      setDisplayBoardingsListReturn(dboarding);

      // get uniq dropping points from response
      const alldroppings = map(returnJourneyData, "Droppings");
      // console.log("All Droppings");
      // console.log(alldroppings);
      // console.log(flatten(alldroppings));
      let allDroppingPoints = uniqBy(flatten(alldroppings), "PointName");
      //console.log(allDroppingPoints);
      allDroppingPoints = orderBy(
        allDroppingPoints,
        [(point) => point.PointName.toLowerCase()],
        ["asc"],
      );
      //console.log(allDroppingPoints);
      setUniqDroppingsReturn(allDroppingPoints);
      const dDropping = showAllDroppings
        ? allDroppingPoints
        : allDroppingPoints.slice(0, 2);
      setDisplayDroppingsListReturn(dDropping);

      // get uniq Bus types  from response
      //const allbustypes = map(journeyData, "CoachType");
      const allbustypes = uniqBy(journeyData, "CoachType");
      // console.log("All Bus Types");
      // console.log(allbustypes);

      setUniqBustypesReturn(allbustypes);
      //console.log("Amentires ")

      const allAmenities = map(journeyData, "Amenities");
      //console.log(allAmenities);

      const uniqAmenitieslist = uniqBy(flatten(allAmenities), "AmenityName");

      //console.log(uniqAmenitieslist);
      setUniqAmenitiesReturn(uniqAmenitieslist);

      // console.log(flatten(alldroppings));
      // const allDroppingPoints = uniqBy(flatten(alldroppings), "PointName");
      // console.log(allDroppingPoints);
      // setUniqDroppings(allDroppingPoints);
    }


  }


  // const  sendEventTobackend = async (eventName, eventValue , eventFrom ) =>{
  //     const TrviaAndMisData = MISBookingMode();
  //     let deviceId = null;
  //     let deviceDaySession = null

  //     if(window.SessionConstants.DEVICE_INFO_KEY ){
  //         deviceId =localStorage.getItem(window.SessionConstants.DEVICE_INFO_KEY);
  //     }

  //     if(window.SessionConstants.DEVICE_SESSION_KEY){
  //        deviceDaySession = JSON.parse(localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY)); 
  //     }
       
  //     console.log(eventName);
  //     console.log(toSafeString(eventValue));
  //     console.log(eventFrom);
  //     console.log(deviceId);
  //     console.log(deviceDaySession);


  //     const payload = {
  //       RegistrationUniqueID : deviceId,
  //       SessionUniqueID :deviceDaySession.sessionId,
  //       MobileNumber : "",
  //       EventName : toSafeString(eventName),
  //       TRVia : TrviaAndMisData.deviceType
  //     }


  //     const response = await axios.post('/send-event-to-backend', payload, {
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     });

  //     console.log(response);


  // }


//   function toSafeString(value) {
//   if (value === null || value === undefined) {
//     return "";
//   }

//   if (typeof value === "string") {
//     return value;
//   }

//   try {
//     return JSON.stringify(value);
//   } catch (e) {
//     return String(value);
//   }
// }

  return (
    <PathProvider
      initialPaths={{
        bookingPageUrl: bookingPageUrl,
        layouturl: layouturl,
        journeySeatsInfo: journeySeatsInfo,
        BookSeatsTempEndPoint: BookSeatsTempEndPoint,
        ServerBaseUrl: ServerBaseUrl,
        LocalwebUrl: LocalwebUrl,
        redirectToPg: redirectToPg,
        componentLoaderflag: false,
        modifyAutoSearch: modifyAutoSearch,
        alterSeatBookingInfo : alterSeatBookingInfo,
        postponeOrpreponeResultUrl : postponeOrpreponeResultUrl,
      }}
    >
      <section className="fixed-max-width">
        <div className="bookingpage-search-container " style={{}}></div>
        <ModifySearchBookingDate
          citiesDataUrl={citiesDataUrl}
          componentName="booking"
          config={calendarDefaultConfig}
          onChangeDestinationConfigUrl={onchangeDestChangeCalendarConfigApi}
          onSearchModify={(payload) => {
            //console.log(payload)
          }}
          selectedSourceFromSearch={journeySourceCity}
          selectedDestinationFromSearch={journeyDestinationCity}
          selectedOnwardFromdate={journeyOnwardDate}
          selectedOnwardTodate={journeyReturnDate}

          showSearchSmallPanel={showSearchSmallPanel} 
          setShowSearchSmallPanel={setShowSearchSmallPanel} 

        />
        <div className="fixed-max-width">
          <div className="journey-section">
            <div className="journey-section-content">
            { currentJourney == 'onward' &&  <div className="journey-filter-section">
                {/* filter section */}

                <div
                  className="filters"
                  onClick={() => {
                    setShowAnimation((prev) => (prev = !prev));
                    window.location.reload();
                  }}
                >
                  <h3>
                    Filters | <span> Clear Filters</span>
                  </h3>
                </div>

                {/* <div className="horizontal-line"></div> */}

                {/* <div className="bustype-section">
                  <h3>Live Location</h3>
                  <div className="bustype-chip">
                    <input type="checkbox" value={""} id="tr2" />
                    <label htmlFor="tr2">Live Tracking</label>  
                  </div>
                </div> */}

                <div className="horizontal-line"></div>
                <Accordion
                  sx={{
                    boxShadow: "none", // Removes the default elevation shadow
                    "&:not(:last-child)": {
                      borderBottom: 0,
                    },
                    "&::before": {
                      display: "none", // Removes the line separating panels
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<MdExpandMore />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    slotProps={{
                      expandIconWrapper: {
                        sx: {
                          color: "#3D18B5",
                          fontSize: "1.3rem",
                          fontWeight: "600",
                        },
                      },
                    }}
                  >
                    <Typography sx={{ color: "#3D18B5", fontWeight: "600" }}>
                      {" "}
                      Departure Time
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="departure-time-accordian">
                      <span
                        className={
                          selectedDeparture === "earlyDepartMorning"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        //  onClick={()=>handleFilterButtonsClick('earlyDepartMorning')}
                        onClick={() =>
                          setSelectedDeparture("earlyDepartMorning")
                        }
                      >
                        <span className="chip-icon "></span>
                        <span>Before 6 AM</span>
                      </span>
                      <span
                        className={
                          selectedDeparture === "departMorning"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        // onClick={()=>handleFilterButtonsClick('departMorning')}

                        onClick={() => setSelectedDeparture("departMorning")}
                      >
                        <span className="chip-icon cicon1"></span>
                        <span>6 AM to 12 PM</span>
                      </span>

                      <span
                        className={
                          selectedDeparture === "departAfterNoon"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        //onClick={()=>handleFilterButtonsClick('departAfterNoon')}

                        onClick={() => setSelectedDeparture("departAfterNoon")}
                      >
                        <span className="chip-icon cicon2"></span>
                        <span>12 PM to 6 PM</span>
                      </span>

                      <span
                        className={
                          selectedDeparture === "departEvening"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        //onClick={()=>handleFilterButtonsClick('departEvening')}

                        onClick={() => setSelectedDeparture("departEvening")}
                      >
                        <span className="chip-icon cicon3"></span>
                        <span>After 6 PM</span>
                      </span>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  sx={{
                    boxShadow: "none", // Removes the default elevation shadow
                    "&:not(:last-child)": {
                      borderBottom: 0,
                    },
                    "&::before": {
                      display: "none", // Removes the line separating panels
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<MdExpandMore />}
                    aria-controls="arrivaltime-content"
                    id="arrivaltime-header"
                    slotProps={{
                      expandIconWrapper: {
                        sx: {
                          color: "#3D18B5",
                          fontSize: "1.3rem",
                          fontWeight: "600",
                        },
                      },
                    }}
                  >
                    <Typography sx={{ color: "#3D18B5", fontWeight: "600" }}>
                      {" "}
                      Arrival Time
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="departure-time-accordian">
                      <span
                        className={
                          selectedArrival === "earlyArrivalMorning"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        //onClick={()=>handleFilterButtonsClick('earlyArrivalMorning')}
                        onClick={() =>
                          setSelectedArrival("earlyArrivalMorning")
                        }
                      >
                        <span className="chip-icon "></span>
                        <span>Before 6 AM</span>
                      </span>
                      <span
                        className={
                          selectedArrival === "arrivalMorning"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        // onClick={()=>handleFilterButtonsClick('arrivalMorning')}

                        onClick={() => setSelectedArrival("arrivalMorning")}
                      >
                        <span className="chip-icon cicon1"></span>
                        <span>6 AM to 12 PM</span>
                      </span>

                      <span
                        className={
                          selectedArrival === "arrivalAfterNoon"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        //onClick={()=>handleFilterButtonsClick('arrivalAfterNoon')}

                        onClick={() => setSelectedArrival("arrivalAfterNoon")}
                      >
                        <span className="chip-icon cicon2"></span>
                        <span>12 PM to 6 PM</span>
                      </span>

                      <span
                        className={
                          selectedArrival === "arrivalEvening"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        //onClick={()=>handleFilterButtonsClick('arrivalEvening')}
                        onClick={() => setSelectedArrival("arrivalEvening")}
                      >
                        <span className="chip-icon cicon3"></span>
                        <span>After 6 PM</span>
                      </span>
                    </div>
                  </AccordionDetails>
                </Accordion>

                <div className="horizontal-line"></div>
                <div className="bustype-section">
                  <h3>Bus Type</h3>
                  {uniqBustypes &&
                    uniqBustypes.map((item) => (
                      <div className="bustype-chip" key={item.CoachType}>
                        <input
                          type="checkbox"
                          id={item.CoachType}
                          checked={selectedBusTypes.includes(item.CoachType)}
                          onChange={() =>
                            handleCheckboxChange(item.CoachType, "bustype")
                          }
                        />
                        <label htmlFor={item.CoachType}>
                          {" "}
                          {item.CoachType}
                        </label>
                      </div>
                    ))}
                </div>

                <div className="horizontal-line"></div>
                <div className="places-list">
                  <h3>Pickup Place</h3>
                  <div className="search-box">
                    <input
                      type="text"
                      onKeyUp={(e) => {
                        filter_board_dropiing(e, "boardings");
                      }}
                    />
                    <div className="search-icon">
                      <CiSearch />
                    </div>
                  </div>

                  <div className="places">
                    {displayBoardingsList &&
                      displayBoardingsList.map((item) => (
                        <div
                          className="places-chips"
                          key={item.BoardingPointID + "-" + item.DepartureTime}
                        >
                          <input
                            type="checkbox"
                            id={item.BoardingPointID}
                            checked={selectedBoardings.includes(item.PointName)}
                            onChange={() =>
                              handleCheckboxChange(item.PointName, "boarding")
                            }
                          ></input>
                          <label htmlFor={item.BoardingPointID}>
                            {item.PointName}
                          </label>
                        </div>
                      ))}
                  </div>
                  {showAllBoardings ? (
                    <div className="places">
                      {" "}
                      <h4
                        onClick={() =>
                          setShowAllBoardings((perv) => (perv = !perv))
                        }
                      >
                        Show Less Pickup Points
                      </h4>
                    </div>
                  ) : (
                    <div className="places">
                      <h4
                        onClick={() =>
                          setShowAllBoardings((perv) => (perv = !perv))
                        }
                      >
                        View More Pickup Points
                      </h4>
                    </div>
                  )}
                </div>

                <div className="horizontal-line"></div>

                <div className="places-list">
                  <h3>Dropping Point</h3>
                  <div className="search-box">
                    <input
                      type="text"
                      onKeyUp={(e) => {
                        filter_board_dropiing(e, "droppings");
                      }}
                    />
                    <div className="search-icon">
                      <CiSearch />
                    </div>
                  </div>

                  <div className="places">
                    {displayDroppingsList &&
                      displayDroppingsList.map((item) => (
                        <div
                          className="places-chips"
                          key={item.BoardingPointID + "-" + item.ArrivalTime}
                        >
                          <input
                            type="checkbox"
                            id={item.BoardingPointID}
                            checked={selectedDroppings.includes(item.PointName)}
                            onChange={() =>
                              handleCheckboxChange(item.PointName, "dropping")
                            }
                          ></input>
                          <label htmlFor={item.BoardingPointID}>
                            {item.PointName}
                          </label>
                        </div>
                      ))}
                  </div>

                  {showAllDroppings ? (
                    <div className="places">
                      <h4
                        onClick={() =>
                          setShowAllDroppings((perv) => (perv = !perv))
                        }
                      >
                        Show Less Dropping Point
                      </h4>
                    </div>
                  ) : (
                    <div className="places">
                      <h4
                        onClick={() =>
                          setShowAllDroppings((perv) => (perv = !perv))
                        }
                      >
                        View More Dropping Point
                      </h4>
                    </div>
                  )}
                </div>

                <div className="horizontal-line"></div>

                <div className="amenities">
                  <h3>Amenities</h3>
                  <div className="amenities-content">
                    {uniqAmenities?.map(
                      (amenity) =>
                        amenity && (
                          <span
                            key={amenity?.AmenityID}
                            className={`amenities-chips ${
                              activeAmenities.includes(amenity?.AmenityID)
                                ? "amenities-active"
                                : ""
                            }`}
                            onClick={() => toggleAmenity(amenity)}
                          >
                            <span className="amenities-icon">
                              <img
                                src={`/icons/amenities/${amenity?.IconImage}`}
                                width={"25px"}
                              />
                            </span>
                            <span style={{ paddingLeft: "5px" }}>
                              {amenity?.AmenityName}
                            </span>
                          </span>
                        ),
                    )}
                  </div>
                </div>

                {/* end of filter section */}
              </div>
            }


            { currentJourney == 'return' &&  <div className="journey-filter-section">
                {/* filter section */}

                <div
                  className="filters"
                  onClick={() => {
                    setShowAnimation((prev) => (prev = !prev));
                    window.location.reload();
                  }}
                >
                  <h3>
                    Filters | <span> Clear Filters</span>
                  </h3>
                </div>

               

                <div className="horizontal-line"></div>
                <Accordion
                  sx={{
                    boxShadow: "none", 
                    "&:not(:last-child)": {
                      borderBottom: 0,
                    },
                    "&::before": {
                      display: "none", 
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<MdExpandMore />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    slotProps={{
                      expandIconWrapper: {
                        sx: {
                          color: "#3D18B5",
                          fontSize: "1.3rem",
                          fontWeight: "600",
                        },
                      },
                    }}
                  >
                    <Typography sx={{ color: "#3D18B5", fontWeight: "600" }}>
                      {" "}
                      Departure Time
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="departure-time-accordian">
                      <span
                        className={
                          selectedDepartureReturn === "earlyDepartMorning"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                       
                        onClick={() =>
                          setSelectedDepartureReturn("earlyDepartMorning")
                        }
                      >
                        <span className="chip-icon "></span>
                        <span>Before 6 AM</span>
                      </span>
                      <span
                        className={
                          selectedDepartureReturn === "departMorning"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                       

                        onClick={() => setSelectedDepartureReturn("departMorning")}
                      >
                        <span className="chip-icon cicon1"></span>
                        <span>6 AM to 12 PM</span>
                      </span>

                      <span
                        className={
                          selectedDepartureReturn === "departAfterNoon"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        

                        onClick={() => setSelectedDepartureReturn("departAfterNoon")}
                      >
                        <span className="chip-icon cicon2"></span>
                        <span>12 PM to 6 PM</span>
                      </span>

                      <span
                        className={
                          selectedDepartureReturn === "departEvening"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        

                        onClick={() => setSelectedDepartureReturn("departEvening")}
                      >
                        <span className="chip-icon cicon3"></span>
                        <span>After 6 PM</span>
                      </span>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  sx={{
                    boxShadow: "none", 
                    "&:not(:last-child)": {
                      borderBottom: 0,
                    },
                    "&::before": {
                      display: "none", 
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<MdExpandMore />}
                    aria-controls="arrivaltime-content"
                    id="arrivaltime-header"
                    slotProps={{
                      expandIconWrapper: {
                        sx: {
                          color: "#3D18B5",
                          fontSize: "1.3rem",
                          fontWeight: "600",
                        },
                      },
                    }}
                  >
                    <Typography sx={{ color: "#3D18B5", fontWeight: "600" }}>
                      
                      Arrival Time
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="departure-time-accordian">
                      <span
                        className={
                          selectedArrivalReturn === "earlyArrivalMorning"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        
                        onClick={() =>
                          setSelectedArrivalReturn("earlyArrivalMorning")
                        }
                      >
                        <span className="chip-icon "></span>
                        <span>Before 6 AM</span>
                      </span>
                      <span
                        className={
                          selectedArrivalReturn === "arrivalMorning"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        

                        onClick={() => setSelectedArrivalReturn("arrivalMorning")}
                      >
                        <span className="chip-icon cicon1"></span>
                        <span>6 AM to 12 PM</span>
                      </span>

                      <span
                        className={
                          selectedArrivalReturn === "arrivalAfterNoon"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        

                        onClick={() => setSelectedArrivalReturn("arrivalAfterNoon")}
                      >
                        <span className="chip-icon cicon2"></span>
                        <span>12 PM to 6 PM</span>
                      </span>

                      <span
                        className={
                          selectedArrivalReturn === "arrivalEvening"
                            ? "chips selected-active-chip"
                            : "chips"
                        }
                        
                        onClick={() => setSelectedArrivalReturn("arrivalEvening")}
                      >
                        <span className="chip-icon cicon3"></span>
                        <span>After 6 PM</span>
                      </span>
                    </div>
                  </AccordionDetails>
                </Accordion>

                <div className="horizontal-line"></div>
                <div className="bustype-section">
                  <h3>Bus Type</h3>
                  {uniqBustypesReturn &&
                    uniqBustypesReturn.map((item) => (
                      <div className="bustype-chip" key={item.CoachType}>
                        <input
                          type="checkbox"
                          id={item.CoachType}
                          checked={selectedBusTypesReturn.includes(item.CoachType)}
                          onChange={() =>
                            handleCheckboxChangeReturn(item.CoachType, "bustype")
                          }
                        />
                        <label htmlFor={item.CoachType}>
                          
                          {item.CoachType}
                        </label>
                      </div>
                    ))}
                </div>

                <div className="horizontal-line"></div>
                <div className="places-list">
                  <h3>Pickup Place</h3>
                  <div className="search-box">
                    <input
                      type="text"
                      onKeyUp={(e) => {
                        filter_board_dropiingReturn(e, "boardings");
                      }}
                    />
                    <div className="search-icon">
                      <CiSearch />
                    </div>
                  </div>

                  <div className="places">
                    {displayBoardingsListReturn &&
                      displayBoardingsListReturn.map((item) => (
                        <div
                          className="places-chips"
                          key={item.BoardingPointID + "-" + item.DepartureTime}
                        >
                          <input
                            type="checkbox"
                            id={item.BoardingPointID}
                            checked={selectedBoardingsReturn.includes(item.PointName)}
                            onChange={() =>
                              handleCheckboxChangeReturn(item.PointName, "boarding")
                            }
                          ></input>
                          <label htmlFor={item.BoardingPointID}>
                            {item.PointName}
                          </label>
                        </div>
                      ))}
                  </div>
                  {showAllBoardingsReturn ? (
                    <div className="places">
                      {" "}
                      <h4
                        onClick={() =>
                          setShowAllBoardingsReturn((perv) => (perv = !perv))
                        }
                      >
                        Show Less Pickup Points
                      </h4>
                    </div>
                  ) : (
                    <div className="places">
                      <h4
                        onClick={() =>
                          setShowAllBoardingsReturn((perv) => (perv = !perv))
                        }
                      >
                        View More Pickup Points
                      </h4>
                    </div>
                  )}
                </div>

                <div className="horizontal-line"></div>

                <div className="places-list">
                  <h3>Dropping Point</h3>
                  <div className="search-box">
                    <input
                      type="text"
                      onKeyUp={(e) => {
                        filter_board_dropiingReturn(e, "droppings");
                      }}
                    />
                    <div className="search-icon">
                      <CiSearch />
                    </div>
                  </div>

                  <div className="places">
                    {displayDroppingsListReturn &&
                      displayDroppingsListReturn.map((item) => (
                        <div
                          className="places-chips"
                          key={item.BoardingPointID + "-" + item.ArrivalTime}
                        >
                          <input
                            type="checkbox"
                            id={item.BoardingPointID}
                            checked={selectedDroppingsReturn.includes(item.PointName)}
                            onChange={() =>
                              handleCheckboxChangeReturn(item.PointName, "dropping")
                            }
                          ></input>
                          <label htmlFor={item.BoardingPointID}>
                            {item.PointName}
                          </label>
                        </div>
                      ))}
                  </div>

                  {showAllDroppingsReturn ? (
                    <div className="places">
                      <h4
                        onClick={() =>
                          setShowAllDroppingsReturn((perv) => (perv = !perv))
                        }
                      >
                        Show Less Dropping Point
                      </h4>
                    </div>
                  ) : (
                    <div className="places">
                      <h4
                        onClick={() =>
                          setShowAllDroppingsReturn((perv) => (perv = !perv))
                        }
                      >
                        View More Dropping Point
                      </h4>
                    </div>
                  )}
                </div>

                <div className="horizontal-line"></div>

                <div className="amenities">
                  <h3>Amenities</h3>
                  <div className="amenities-content">
                    {uniqAmenitiesReturn?.map(
                      (amenity) =>
                        amenity && (
                          <span
                            key={amenity?.AmenityID}
                            className={`amenities-chips ${
                              activeAmenities.includes(amenity?.AmenityID)
                                ? "amenities-active"
                                : ""
                            }`}
                            onClick={() => toggleAmenity(amenity)}
                          >
                            <span className="amenities-icon">
                              <img
                                src={`/icons/amenities/${amenity?.IconImage}`}
                                width={"25px"}
                              />
                            </span>
                            <span style={{ paddingLeft: "5px" }}>
                              {amenity?.AmenityName}
                            </span>
                          </span>
                        ),
                    )}
                  </div>
                </div>

                {/* end of filter section */}
              </div>
             }
              <div className="journey-list-section">
                <TabContext value={tabValue}>
                  <div className="journey-route-headers">
                    <Tabs
                      value={tabValue}
                      onChange={handleJourneyTabChange}
                      textColor="primary"
                      indicatorColor="primary"
                      sx={{
                        padding:"0px",
                         minHeight: 0, 
                      }}
                    >
                      <Tab
                        className="city-headers"
                        label={
                          journeySourceCity?.CityName +
                          " to " +
                          journeyDestinationCity?.CityName
                        }
                        value="1"
                        sx={{
                          // Your Custom Styles
                          backgroundColor: "var(--button)",
                          padding: "8px 16px",
                          color: "var(--primary)",
                          fontWeight: 600,
                          borderTopRightRadius: "10px",
                          borderTopLeftRadius: "10px",
                          cursor: "pointer",
                          textTransform: "none", // Prevents forced Uppercase
                          minHeight: "auto", // Ensures padding controls the height

                          // Ensuring the color stays visible when selected
                          "&.Mui-selected": {
                            color: "var(--primary)",
                            filter: "brightness(1)", // Slight visual change for active tab
                          },

                          // Adding a small margin so the tabs don't touch
                          marginRight: "4px",
                        }}
                      />

                      { isReturnJourneyExsit && (
                         <Tab
                        label={
                          journeyDestinationCity?.CityName +
                          " to " +
                          journeySourceCity?.CityName
                        }
                        value="2"
                        sx={{
                          // Your Custom Styles
                          backgroundColor: "var(--button)",
                          padding: "8px 16px",
                          color: "var(--primary)",
                          fontWeight: 600,
                          borderTopRightRadius: "10px",
                          borderTopLeftRadius: "10px",
                          cursor: "pointer",
                          textTransform: "none", // Prevents forced Uppercase
                          minHeight: "auto", // Ensures padding controls the height

                          // Ensuring the color stays visible when selected
                          "&.Mui-selected": {
                            color: "var(--primary)",
                            filter: "brightness(1)", // Slight visual change for active tab
                          },

                          // Adding a small margin so the tabs don't touch
                          marginRight: "4px",
                        }}
                      />

                      )

                      }
                     
                    </Tabs>

                    <div className="journey-route-cities ">
                      <span className="city-headers d-none-sm">
                        15% off on all bookings.
                      </span>
                    </div>
                  </div>

                  <div className="journey-list">
                    {/* Sorting Labels - Remains consistent for both tabs */}
                    {
                      currentJourney == 'onward' && <>

                          <div className="journey-labels">
                      <span className="jlabels jlabels-bold">
                        {
                           filteredJourneyData?.length 
                        }
                         &nbsp; Buses Found
                      </span>
                      <span
                        className="jlabels"
                        onClick={() => sortBy("Departure")}
                      >
                        {" "}
                        Departure {getSortIcon("Departure")}{" "}
                      </span>
                      <span
                        className="jlabels"
                        onClick={() => sortBy("Duration")}
                      >
                        {" "}
                        Duration {getSortIcon("Duration")}{" "}
                      </span>
                      <span
                        className="jlabels"
                        onClick={() => sortBy("Arrival")}
                      >
                        {" "}
                        Arrival {getSortIcon("Arrival")}{" "}
                      </span>
                      <span className="jlabels" onClick={() => sortBy("Seat")}>
                        {" "}
                        Seats {getSortIcon("Seat")}{" "}
                      </span>
                      <span className="jlabels" onClick={() => sortBy("Fare")}>
                        {" "}
                        Fare {getSortIcon("Fare")}{" "}
                      </span>
                    </div>

                      </>
                    }


                    {
                      currentJourney == 'return' && <>
                         <div className="journey-labels">
                      <span className="jlabels jlabels-bold">
                        {
                           returnFilteredJourneyData?.length || 0

                        }
                         &nbsp; Buses Found
                      </span>
                      <span
                        className="jlabels"
                        onClick={() => sortByReturn("Departure")}
                      >
                        {" "}
                        Departure {getSortIconReturn("Departure")}{" "}
                      </span>
                      <span
                        className="jlabels"
                        onClick={() => sortByReturn("Duration")}
                      >
                        {" "}
                        Duration {getSortIconReturn("Duration")}{" "}
                      </span>
                      <span
                        className="jlabels"
                        onClick={() => sortByReturn("Arrival")}
                      >
                        {" "}
                        Arrival {getSortIconReturn("Arrival")}{" "}
                      </span>
                      <span className="jlabels" onClick={() => sortByReturn("Seat")}>
                        {" "}
                        Seats {getSortIconReturn("Seat")}{" "}
                      </span>
                      <span className="jlabels" onClick={() => sortByReturn("Fare")}>
                        {" "}
                        Fare {getSortIconReturn("Fare")}{" "}
                      </span>
                    </div>
                      </>
                    }
                   

                    <div className="card-container">
                      {/* Content for Onward Tab */}
                      {tabValue === "1" && (
                        <div className="tab-panel-content">
                          {filteredJourneyData &&
                          filteredJourneyData.length > 0 ? (
                            filteredJourneyData.map((item) => (
                              <RouteCardNew
                                key={item.JourneyID}
                                routeobject={item}
                                paymentUrl={paymentUrl}
                                journeytype="onward"
                                handleTabChangeInDialog = {handleTabChangeInDialog}
                                journeyDialogOpen={journeyDialogOpen} 
                                setJourneyDialogOpen={setJourneyDialogOpen} 
                                activeJourneyId={activeJourneyId}        
                                setActiveJourneyId={setActiveJourneyId}    
                                
                              />
                            ))
                          ) : (
                            <>
                              <div className="no-results" style={{display:'flex',alignItems:'center',justifyContent:'center',border:'1px solid #F0C800',width:'100%',height:'100%',padding:'16px'}}> <h6 style={{fontSize:'16px',color:'#2D40A9'}}>No journeys found.</h6></div>
                            </>
                          )}
                        </div>
                      )}    

                      {/* Content for Return Tab */}
                     
                      { tabValue === "2" && (
                        <div className="tab-panel-content">
                          {returnFilteredJourneyData &&
                          returnFilteredJourneyData.length > 0 ? (
                            returnFilteredJourneyData.map((item) => (
                              <RouteCardNew
                                key={item.JourneyID}
                                routeobject={item}
                                paymentUrl={paymentUrl}
                                journeytype="return" 
                                handleTabChangeInDialog = {handleTabChangeInDialog}
                                journeyDialogOpen={journeyDialogOpen} 
                                setJourneyDialogOpen={setJourneyDialogOpen} 
                                activeJourneyId={activeJourneyId}        
                                setActiveJourneyId={setActiveJourneyId}    

                              /> 
                            ))
                          ) : (
                            <>
                              <div className="no-results" style={{display:'flex',alignItems:'center',justifyContent:'center',border:'1px solid #F0C800',width:'100%',height:'100%',padding:'16px'}}> <h6 style={{fontSize:'16px',color:'#2D40A9'}}>No journeys found.</h6></div>
                            </>
                          )}
                        </div>
                      )}
                 
                    </div>
                  </div>
                </TabContext>
              </div>
            </div>
          </div>
        </div>
        {/* filter dailog */}
        <button className="floating-filter-button" onClick={handleClickOpen}>
          <span className="filter-text">
            <span className="icon">
              <FiFilter />
            </span>
            <small className="text">Filters</small>
          </span>
        </button>
        <>
          <Dialog
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            fullWidth
            maxWidth="md"
            PaperProps={{
              sx: {
                m: 0,
                position: "fixed",
                bottom: 0,
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                width: "100%",
                height: { xs: "60vh", md: "60vh" },
                display: "flex",
                flexDirection: "row",
                overflow: "hidden",
              },
            }}
          >
            {/* LEFT SIDENAV */}
            <Box
              sx={{
                width: { xs: "30%", md: "30%" },
                bgcolor: "#f4f3ff",

                pt: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  p: 0,
                  bgcolor: "#f4f3ff", // light background (menu-like)
                  borderRight: "1px solid #e0e0e0", // subtle divider
                }}
              >
                <List
                  dense
                  sx={{
                    p: 0, // remove default list padding
                  }}
                >
                  {[
                    "Sort",
                    "Departure",
                    "Arrival",
                    "Bus Type",
                    "Pickup",
                    "Dropping",
                    "Amenities",
                  ].map((text) => (
                    <ListItem
                      key={text}
                      sx={{
                        py: 0.5,
                        px: 1,
                        color: "#3D18B5",
                        fontSize: "12px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#fcfcfc", // hover effect like menu
                        },
                      }}
                      onClick={() => handleSmMenuSelect(text)}
                    >
                      <ListItemText
                        primary={text}
                        primaryTypographyProps={{
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
              {/* <Button variant="outlined" onClick={handleClose}>
                Close
              </Button> */}
            </Box>

            {/* RIGHT CONTENT */}
            <Box
              sx={{
                flex: 1,
                pt: 5,
                overflowY: "auto",
                bgcolor: "#fcfcfc",
              }}
            >
              <Box
                style={{
                  display: smFilterSelectedMenu == "Sort" ? "block" : "none",
                }}
              >


                {
                  currentJourney == 'onward' && <>

                    <div className="filter-sort-part">
                  <div className="sort-input-chips">
                    <input
                      type="radio"
                      name="sort"
                      checked={
                        sortingSmScreenRadio == "Departure" ? true : false
                      }
                      id="departure"
                      onClick={() => {
                        sortBy("Departure");
                        setSortingSmScreenRadio("Departure");
                      }}
                      readOnly
                    />
                    <label htmlFor="departure">
                      {" "}
                      Sort By Departure Time {getSortIcon("Departure")}
                    </label>
                  </div>

                  <div className="sort-input-chips">
                    <input
                      type="radio"
                      name="sort"
                      checked={
                        sortingSmScreenRadio == "Duration" ? true : false
                      }
                      id="duration"
                      onClick={() => {
                        sortBy("Duration");
                        setSortingSmScreenRadio("Duration");
                      }}
                      readOnly
                    />
                    <label htmlFor="duration">
                      {" "}
                      Sort By Duration {getSortIcon("Duration")}{" "}
                    </label>
                  </div>
                  <div className="sort-input-chips">
                    <input
                      type="radio"
                      name="sort"
                      checked={sortingSmScreenRadio == "Arrival" ? true : false}
                      id="arrival"
                      onClick={() => {
                        sortBy("Arrival");
                        setSortingSmScreenRadio("Arrival");
                      }}
                      readOnly
                    />
                    <label htmlFor="arrival">
                      {" "}
                      Sort By Arrival Time {getSortIcon("Arrival")}{" "}
                    </label>
                  </div>
                  {/* <div className="sort-input-chips">
                    <input type="radio" name="sort" id="rating" onChange={()=>sortBy('Arrival')} />
                    <label htmlFor="arrival"> Sort By Rating </label>
                  </div> */}

                  <div className="sort-input-chips">
                    <input
                      type="radio"
                      name="sort"
                      checked={sortingSmScreenRadio == "Seat" ? true : false}
                      id="seat"
                      onClick={() => {
                        sortBy("Seat");
                        setSortingSmScreenRadio("Seat");
                      }}
                      readOnly
                    />
                    <label htmlFor="seat">
                      {" "}
                      Sort By Seat Available {getSortIcon("Seat")}{" "}
                    </label>
                  </div>

                  <div className="sort-input-chips">
                    <input
                      type="radio"
                      name="sort"
                      checked={sortingSmScreenRadio == "Fare" ? true : false}
                      id="fare"
                      onClick={() => {
                        sortBy("Fare");
                        setSortingSmScreenRadio("Fare");
                      }}
                      readOnly
                    />
                    <label htmlFor="fare">
                      {" "}
                      Sort By Fare {getSortIcon("Fare")}{" "}
                    </label>
                  </div>
                 </div>

                  </>
                }


                  {
                  currentJourney == 'return' && <>

                    <div className="filter-sort-part">
                  <div className="sort-input-chips">
                    <input
                      type="radio"
                      name="sort"
                      checked={
                        sortingSmScreenRadioReturn == "Departure" ? true : false
                      }
                      id="departure"
                      onClick={() => {
                        sortByReturn("Departure");
                        setSortingSmScreenRadioReturn("Departure");
                      }}
                      readOnly
                    />
                    <label htmlFor="departure">
                      {" "}
                      Sort By Departure Time {getSortIconReturn("Departure")}
                    </label>
                  </div>

                  <div className="sort-input-chips">
                    <input
                      type="radio"
                      name="sort"
                      checked={
                        sortingSmScreenRadioReturn == "Duration" ? true : false
                      }
                      id="duration"
                      onClick={() => {
                        sortByReturn("Duration");
                        setSortingSmScreenRadioReturn("Duration");
                      }}
                      readOnly
                    />
                    <label htmlFor="duration">
                      {" "}
                      Sort By Duration {getSortIconReturn("Duration")}{" "}
                    </label>
                  </div>
                  <div className="sort-input-chips">
                    <input
                      type="radio"
                      name="sort"
                      checked={sortingSmScreenRadioReturn == "Arrival" ? true : false}
                      id="arrival"
                      onClick={() => {
                        sortByReturn("Arrival");
                        setSortingSmScreenRadioReturn("Arrival");
                      }}
                      readOnly
                    />
                    <label htmlFor="arrival">
                      {" "}
                      Sort By Arrival Time {getSortIconReturn("Arrival")}{" "}
                    </label>
                  </div>
                  {/* <div className="sort-input-chips">
                    <input type="radio" name="sort" id="rating" onChange={()=>sortBy('Arrival')} />
                    <label htmlFor="arrival"> Sort By Rating </label>
                  </div> */}

                  <div className="sort-input-chips">
                    <input
                      type="radio"
                      name="sort"
                      checked={sortingSmScreenRadioReturn == "Seat" ? true : false}
                      id="seat"
                      onClick={() => {
                        sortByReturn("Seat");
                        setSortingSmScreenRadioReturn("Seat");
                      }}
                      readOnly
                    />
                    <label htmlFor="seat">
                      {" "}
                      Sort By Seat Available {getSortIconReturn("Seat")}{" "}
                    </label>
                  </div>

                  <div className="sort-input-chips">
                    <input
                      type="radio"
                      name="sort"
                      checked={sortingSmScreenRadioReturn == "Fare" ? true : false}
                      id="fare"
                      onClick={() => {
                        sortByReturn("Fare");
                        setSortingSmScreenRadioReturn("Fare");
                      }}
                      readOnly
                    />
                    <label htmlFor="fare">
                      {" "}
                      Sort By Fare {getSortIconReturn("Fare")}{" "}
                    </label>
                  </div>
                 </div>

                  </>
                }
               
                

                <div className="small-screen-apply-filters">
                  <button className="apply-button" onClick={handleClose}>
                    {" "}
                    Apply & Close{" "}
                  </button>
                </div>
              </Box>

              {/* <Box style={{display:(smFilterSelectedMenu == 'Tracking')?'block':'none'}}>
                <div className="filter-time-part">
                    <div className="sort-input-checks">
                    <input type="checkbox" id="live_tracking" />
                    <label htmlFor="live_tracking"> Live Tracking </label>

                    </div>

                </div>
              </Box> */}

              <Box
                style={{
                  display:
                    smFilterSelectedMenu == "Departure" ? "block" : "none",
                }}
                sx={{ px: 2 }}
              >

               {
                currentJourney == 'onward' && <>
                  <h3 style={{ color: "#3D18B5" }}>Departure Time</h3>
                <div
                  className={
                    selectedDeparture === "earlyDepartMorning"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedDeparture("earlyDepartMorning")}
                >
                  <span className="chip-icon"></span>
                  <p> Before 6 am </p>
                </div>
                <div
                  className={
                    selectedDeparture === "departMorning"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedDeparture("departMorning")}
                >
                  <span className="chip-icon cicon1"></span>
                  <p> 6 am to 12 pm </p>
                </div>

                <div
                  className={
                    selectedDeparture === "departAfterNoon"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedDeparture("departAfterNoon")}
                >
                  <span className="chip-icon cicon2"></span>
                  <p> 12 pm to 6 pm </p>
                </div>

                <div
                  className={
                    selectedDeparture === "departEvening"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedDeparture("departEvening")}
                >
                  <span className="chip-icon cicon3"></span>
                  <p> After 6 pm </p>
                </div>

                <div className="small-screen-apply-filters">
                  <button className="apply-button" onClick={handleClose}>
                    {" "}
                    Apply & Close{" "}
                  </button>
                </div>
                </>
               }





                {
                currentJourney == 'return' && <>
                  <h3 style={{ color: "#3D18B5" }}>Departure Time</h3>
                <div
                  className={
                    selectedDepartureReturn === "earlyDepartMorning"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedDepartureReturn("earlyDepartMorning")}
                >
                  <span className="chip-icon"></span>
                  <p> Before 6 am </p>
                </div>
                <div
                  className={
                    selectedDepartureReturn === "departMorning"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedDepartureReturn("departMorning")}
                >
                  <span className="chip-icon cicon1"></span>
                  <p> 6 am to 12 pm </p>
                </div>

                <div
                  className={
                    selectedDepartureReturn === "departAfterNoon"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedDepartureReturn("departAfterNoon")}
                >
                  <span className="chip-icon cicon2"></span>
                  <p> 12 pm to 6 pm </p>
                </div>

                <div
                  className={
                    selectedDepartureReturn === "departEvening"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedDepartureReturn("departEvening")}
                >
                  <span className="chip-icon cicon3"></span>
                  <p> After 6 pm </p>
                </div>

                <div className="small-screen-apply-filters">
                  <button className="apply-button" onClick={handleClose}>
                    {" "}
                    Apply & Close{" "}
                  </button>
                </div> 
                </>
               }
                
              </Box>

              <Box
                style={{
                  display: smFilterSelectedMenu == "Arrival" ? "block" : "none",
                }}
                sx={{ px: 2 }}
              >
              
              {
                currentJourney == 'onward' && <>
                    <h3 style={{ color: "#3D18B5" }}>Arrival Time</h3>
                <div
                  className={
                    selectedArrival === "earlyArrivalMorning"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedArrival("earlyArrivalMorning")}
                >
                  <span className="chip-icon"></span>
                  <p> Before 6 am </p>
                </div>
                <div
                  className={
                    selectedArrival === "arrivalMorning"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedArrival("arrivalMorning")}
                >
                  <span className="chip-icon cicon1"></span>
                  <p> 6 am to 12 pm </p>
                </div>

                <div
                  className={
                    selectedArrival === "arrivalAfterNoon"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedArrival("arrivalAfterNoon")}
                >
                  <span className="chip-icon cicon2"></span>
                  <p> 12 pm to 6 pm </p>
                </div>

                <div
                  className={
                    selectedArrival === "arrivalEvening"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedArrival("arrivalEvening")}
                >
                  <span className="chip-icon cicon3"></span>
                  <p> After 6 pm </p>
                </div>

                <div className="small-screen-apply-filters">
                  <button className="apply-button" onClick={handleClose}>
                    {" "}
                    Apply & Close{" "}
                  </button>
                </div>
                </>

              }

              {
                currentJourney == 'return' && <>
                    <h3 style={{ color: "#3D18B5" }}>Arrival Time</h3>
                <div
                  className={
                    selectedArrivalReturn === "earlyArrivalMorning"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedArrivalReturn("earlyArrivalMorning")}
                >
                  <span className="chip-icon"></span>
                  <p> Before 6 am </p>
                </div>
                <div
                  className={
                    selectedArrivalReturn === "arrivalMorning"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedArrivalReturn("arrivalMorning")}
                >
                  <span className="chip-icon cicon1"></span>
                  <p> 6 am to 12 pm </p>
                </div>

                <div
                  className={
                    selectedArrivalReturn === "arrivalAfterNoon"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedArrivalReturn("arrivalAfterNoon")}
                >
                  <span className="chip-icon cicon2"></span>
                  <p> 12 pm to 6 pm </p>
                </div>

                <div
                  className={
                    selectedArrivalReturn === "arrivalEvening"
                      ? "timing-chips selected-active-chip"
                      : "timing-chips"
                  }
                  onClick={() => setSelectedArrivalReturn("arrivalEvening")}
                >
                  <span className="chip-icon cicon3"></span>
                  <p> After 6 pm </p>
                </div>

                <div className="small-screen-apply-filters">
                  <button className="apply-button" onClick={handleClose}>
                    {" "}
                    Apply & Close{" "}
                  </button>
                </div>
                </>

                

              }
              </Box>

              <Box
                style={{
                  display:
                    smFilterSelectedMenu == "Bus Type" ? "block" : "none",
                }}
                sx={{ px: 2 }}
              >
                {
                  currentJourney == 'onward' && <>
                    <h3 style={{ color: "#3D18B5" }}>Bus Type</h3>
                <div className="bustype-section">
                  {uniqBustypes &&
                    uniqBustypes.map((item) => (
                      <div className="bustype-chip" key={item.CoachType}>
                        <input
                          type="checkbox"
                          id={item.CoachType}
                          checked={selectedBusTypes.includes(item.CoachType)}
                          onChange={() =>
                            handleCheckboxChange(item.CoachType, "bustype")
                          }
                        />
                        <label htmlFor={item.CoachType}>
                          {" "}
                          {item.CoachType}
                        </label>
                      </div>
                    ))}
                </div>

                <div className="small-screen-apply-filters">
                  <button className="apply-button" onClick={handleClose}>
                    {" "}
                    Apply & Close{" "}
                  </button>
                </div>
                  </>
                }

                {
                  currentJourney == 'return' && <>
                    <h3 style={{ color: "#3D18B5" }}>Bus Type</h3>
                <div className="bustype-section">
                  {uniqBustypesReturn &&
                    uniqBustypesReturn.map((item) => (
                      <div className="bustype-chip" key={item.CoachType}>
                        <input
                          type="checkbox"
                          id={item.CoachType}
                          checked={selectedBusTypesReturn.includes(item.CoachType)}
                          onChange={() =>
                            handleCheckboxChangeReturn(item.CoachType, "bustype")
                          }
                        />
                        <label htmlFor={item.CoachType}>
                          {" "}
                          {item.CoachType}
                        </label>
                      </div>
                    ))}
                </div>

                <div className="small-screen-apply-filters">
                  <button className="apply-button" onClick={handleClose}>
                    {" "}
                    Apply & Close{" "}
                  </button>
                </div>
                  </>
                }
              </Box>

              <Box
                style={{
                  display: smFilterSelectedMenu == "Pickup" ? "block" : "none",
                }}
              >
               {
                currentJourney == 'onward' && <>

                   <div className="places-list">
                  <h3>Pickup Place</h3>
                  <div className="search-box">
                    <input
                      type="text"
                      onKeyUp={(e) => {
                        filter_board_dropiing(e, "boardings");
                      }}
                    />
                    <div className="search-icon">
                      <CiSearch />
                    </div>
                  </div>

                  <div className="places">
                    {displayBoardingsList &&
                      displayBoardingsList.map((item) => (
                        <div
                          className="places-chips"
                          key={item.BoardingPointID + "-" + item.DepartureTime}
                        >
                          <input
                            type="checkbox"
                            id={item.BoardingPointID}
                            checked={selectedBoardings.includes(item.PointName)}
                            onChange={() =>
                              handleCheckboxChange(item.PointName, "boarding")
                            }
                          ></input>
                          <label htmlFor={item.BoardingPointID}>
                            {item.PointName}
                          </label>
                        </div>
                      ))}
                  </div>
                  <div className="places">
                    {showAllBoardings ? (
                      <div className="places">
                        {" "}
                        <h4
                          onClick={() =>
                            setShowAllBoardings((perv) => (perv = !perv))
                          }
                        >
                          Show Less Pickup Points
                        </h4>
                      </div>
                    ) : (
                      <div className="places">
                        <h4
                          onClick={() =>
                            setShowAllBoardings((perv) => (perv = !perv))
                          }
                        >
                          View More Pickup Points
                        </h4>
                      </div>
                    )}
                  </div>
                </div>

                </>
               }

               {
                currentJourney == 'return' && <>
                   <div className="places-list">
                  <h3>Pickup Place</h3>
                  <div className="search-box">
                    <input
                      type="text"
                      onKeyUp={(e) => {
                        filter_board_dropiingReturn(e, "boardings");
                      }}
                    />
                    <div className="search-icon">
                      <CiSearch />
                    </div>
                  </div>

                  <div className="places">
                    {displayBoardingsListReturn &&
                      displayBoardingsListReturn.map((item) => (
                        <div
                          className="places-chips"
                          key={item.BoardingPointID + "-" + item.DepartureTime}
                        >
                          <input
                            type="checkbox"
                            id={item.BoardingPointID}
                            checked={selectedBoardingsReturn.includes(item.PointName)}
                            onChange={() =>
                              handleCheckboxChangeReturn(item.PointName, "boarding")
                            }
                          ></input>
                          <label htmlFor={item.BoardingPointID}>
                            {item.PointName}
                          </label>
                        </div>
                      ))}
                  </div>
                  <div className="places">
                    {showAllBoardingsReturn ? (
                      <div className="places">
                        {" "}
                        <h4
                          onClick={() =>
                            setShowAllBoardingsReturn((perv) => (perv = !perv))
                          }
                        >
                          Show Less Pickup Points
                        </h4>
                      </div>
                    ) : (
                      <div className="places">
                        <h4
                          onClick={() =>
                            setShowAllBoardingsReturn((perv) => (perv = !perv))
                          }
                        >
                          View More Pickup Points
                        </h4>
                      </div>
                    )}
                  </div>
                </div>
                </>
               }
               

                <div className="small-screen-apply-filters">
                  <button className="apply-button" onClick={handleClose}>
                    {" "}
                    Apply & Close{" "}
                  </button>
                </div>
              </Box>

              <Box
                style={{
                  display:
                    smFilterSelectedMenu == "Dropping" ? "block" : "none",
                }}
              >

              {
                currentJourney == 'onward' && <>
                   <div className="places-list">
                  <h3>Dropping Point</h3>
                  <div className="search-box">
                    <input
                      type="text"
                      onKeyUp={(e) => {
                        filter_board_dropiing(e, "droppings");
                      }}
                    />
                    <div className="search-icon">
                      <CiSearch />
                    </div>
                  </div>

                  <div className="places">
                    {displayDroppingsList &&
                      displayDroppingsList.map((item) => (
                        <div
                          className="places-chips"
                          key={item.BoardingPointID + "-" + item.ArrivalTime}
                        >
                          <input
                            type="checkbox"
                            id={item.BoardingPointID}
                            checked={selectedDroppings.includes(item.PointName)}
                            onChange={() =>
                              handleCheckboxChange(item.PointName, "dropping")
                            }
                          ></input>
                          <label htmlFor={item.BoardingPointID}>
                            {item.PointName}
                          </label>
                        </div>
                      ))}
                  </div>
                  {showAllDroppings ? (
                    <div className="places">
                      <h4
                        onClick={() =>
                          setShowAllDroppings((perv) => (perv = !perv))
                        }
                      >
                        Show Less Dropping Point
                      </h4>
                    </div>
                  ) : (
                    <div className="places">
                      <h4
                        onClick={() =>
                          setShowAllDroppings((perv) => (perv = !perv))
                        }
                      >
                        View More Dropping Point
                      </h4>
                    </div>
                  )}
                </div>
                </>
              }
               {
                currentJourney == 'return' && <>
                   <div className="places-list">
                  <h3>Dropping Point</h3>
                  <div className="search-box">
                    <input
                      type="text"
                      onKeyUp={(e) => {
                        filter_board_dropiingReturn(e, "droppings");
                      }}
                    />
                    <div className="search-icon">
                      <CiSearch />
                    </div>
                  </div>

                  <div className="places">
                    {displayDroppingsListReturn &&
                      displayDroppingsListReturn.map((item) => (
                        <div
                          className="places-chips"
                          key={item.BoardingPointID + "-" + item.ArrivalTime}
                        >
                          <input
                            type="checkbox"
                            id={item.BoardingPointID}
                            checked={selectedDroppingsReturn.includes(item.PointName)}
                            onChange={() =>
                              handleCheckboxChange(item.PointName, "dropping")
                            }
                          ></input>
                          <label htmlFor={item.BoardingPointID}>
                            {item.PointName}
                          </label>
                        </div>
                      ))}
                  </div>
                  {showAllDroppings ? (
                    <div className="places">
                      <h4
                        onClick={() =>
                          setShowAllDroppingsReturn((perv) => (perv = !perv))
                        }
                      >
                        Show Less Dropping Point
                      </h4>
                    </div>
                  ) : (
                    <div className="places">
                      <h4
                        onClick={() =>
                          setShowAllDroppingsReturn((perv) => (perv = !perv))
                        }
                      >
                        View More Dropping Point
                      </h4>
                    </div>
                  )}
                </div>
                </>
               }

                <div className="small-screen-apply-filters">
                  <button className="apply-button" onClick={handleClose}>
                    {" "}
                    Apply & Close{" "}
                  </button>
                </div>
              </Box>

              <Box
                style={{
                  display:
                    smFilterSelectedMenu == "Amenities" ? "block" : "none",
                }}
              >
                {
                  currentJourney == 'onward' && <>
                    <div className="amenities">
                  <h3>Amenities</h3>
                  <div className="amenities-content">
                    {uniqAmenities?.map(
                      (amenity) =>
                        amenity && (
                          <span
                            key={amenity?.AmenityID}
                            className={`amenities-chips ${
                              activeAmenities.includes(amenity?.AmenityID)
                                ? "amenities-active"
                                : ""
                            }`}
                            onClick={() => toggleAmenity(amenity)}
                          >
                            <span className="amenities-icon">
                              <img
                                src={`/icons/amenities/${amenity?.IconImage}`}
                                width={"25px"}
                              />
                            </span>
                            <span style={{ paddingLeft: "5px" }}>
                              {amenity?.AmenityName}
                            </span>
                          </span>
                        ),
                    )}
                  </div>
                </div>
                  </>
                }

                {
                  currentJourney == 'return' && <>
                    <div className="amenities">
                  <h3>Amenities</h3>
                  <div className="amenities-content">
                    {uniqAmenitiesReturn?.map(
                      (amenity) =>
                        amenity && (
                          <span
                            key={amenity?.AmenityID}
                            className={`amenities-chips ${
                              activeAmenities.includes(amenity?.AmenityID)
                                ? "amenities-active"
                                : ""
                            }`}
                            onClick={() => toggleAmenity(amenity)}
                          >
                            <span className="amenities-icon">
                              <img
                                src={`/icons/amenities/${amenity?.IconImage}`}
                                width={"25px"}
                              />
                            </span>
                            <span style={{ paddingLeft: "5px" }}>
                              {amenity?.AmenityName}
                            </span>
                          </span>
                        ),
                    )}
                  </div>
                </div>
                  </>
                }

                <div className="small-screen-apply-filters">
                  <button className="apply-button" onClick={handleClose}>
                    {" "}
                    Apply & Close{" "}
                  </button>
                </div>
              </Box>
            </Box>
          </Dialog>
        </>
      </section>

      {/* end of main section */}

      <GlobalLoaderRoot />
    </PathProvider>
  );
};

export default JourneyList;
